export const BASE_INPUT_UPLOADER_REMOTE_PAYLOAD = Symbol.for(
  'kvest.baseInputUploader.remotePayload',
)

export interface BaseInputUploaderRemoteResolved {
  previewUrl: string
  fileName: string
  mimeType?: string
  fileSize?: number | null
}

export type BaseInputUploaderRemoteResolve = (
  payload: unknown,
) => BaseInputUploaderRemoteResolved

export interface BaseInputUploaderRemotePayload {
  [BASE_INPUT_UPLOADER_REMOTE_PAYLOAD]: true
  id: string
  payload: unknown
}

export type BaseInputUploaderModelValue = File | BaseInputUploaderRemotePayload

export function isBaseInputUploaderRemotePayload(
  v: unknown,
): v is BaseInputUploaderRemotePayload {
  return (
    typeof v === 'object'
    && v !== null
    && BASE_INPUT_UPLOADER_REMOTE_PAYLOAD in v
    && (v as BaseInputUploaderRemotePayload)[BASE_INPUT_UPLOADER_REMOTE_PAYLOAD] === true
  )
}

export function baseInputUploaderRemotePayload(
  id: string,
  payload: unknown,
): BaseInputUploaderRemotePayload {
  return {
    [BASE_INPUT_UPLOADER_REMOTE_PAYLOAD]: true,
    id,
    payload,
  }
}
